import { Injectable } from '@angular/core';

/**
 * Service for deep cloning objects.
 * Uses structuredClone for deep copying.
 */
@Injectable({ providedIn: 'root' })
export class CloneService {
  /**
   * Creates a deep clone of the provided value.
   * @param value - The value to clone
   * @returns A deep copy of the value
   */
  deepClone<T>(value: T): T {
    return structuredClone(value);
  }
}
